// src/components/Product/Shared/Lightbox.tsx
"use client";

import Image from "next/image";
import { motion, AnimatePresence } from "motion/react";
import { Icon } from "@iconify/react";

export default function Lightbox({ src, onClose }: { src: string | null | undefined; onClose: () => void }) {
  return (
    <AnimatePresence>
      {src && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm p-4" onClick={onClose}>
          <div className="relative w-full h-full max-w-5xl max-h-[90vh] flex items-center justify-center" onClick={(e) => e.stopPropagation()}>
            <button onClick={onClose} className="absolute top-4 right-4 z-50 p-2 bg-white/10 hover:bg-white/20 rounded-full text-white transition-colors">
              <Icon icon="ion:close" width="30" />
            </button>
            <div className="relative w-full h-full">
              <Image src={src} alt="Full View" fill className="object-contain" />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
